<template>
  <div class="po-table">
    <el-table  :data="data" :show-header="isheader" :header-cell-style="headerCellStyle" :row-style="rowStyle"
      :cell-style="cellStyle" @cell-click="cellClick" @row-click="rowClick" style="width: 100%;" :height="tableheight"
      :row-key="rowKey" :tree-props="treeProps" ref="table"
       :infinite-scroll-disabled="infiniteScrollDisabled">
      <el-table-column v-for="(item, index) in column" :key="index+item.prop+item.label" :align="item.align" :width="item.width"
        :min-width="item.minWidth" :fixed="item.fixed">
        <template #header="{ row }">
          <slot name="header" :header="{ item, row }"></slot>
        </template>
        <template #default="{ row }">
          <slot name="default" :default="{ item, row }"></slot>
        </template>
      </el-table-column>
     
      <div slot="empty">
        <van-empty description="暂无数据" />
      </div>
    </el-table>
    <div style="text-align: center;">
        <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array, 
      default: () => []
    },
    
    column: {
      type: Array,
      default: () => []
    },
    headerCellStyle: {
      type: Function
    },
    rowStyle: {
      type: Function
    },
    cellStyle: {
      type: Function
    },
    isheader: {
      type: Boolean,
      default: true
    },
    tableheight: {
      type: Number
    },
    rowKey: {
      type: String,
      default: ''
    },
    treeProps: {
      type: Object,
      default: () => { }
    },
    infiniteScrollDisabled: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 100
    },
    PageNo: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
      return {
        currentPage: this.PageNo,
      }
  },
  methods: {
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    scrollLoad() {
      this.$emit("scrollLoad");
    },
    handleCurrentChange(val){
      this.$emit("handleCurrentChange",val);
    }
    
  },
   watch: {
    "data": {
      handler(res) {
      //  console.log("res",res);
      },
      deep: true,
    },
     // 添加对 PageNo 的监听
    PageNo(newVal) {
      this.currentPage = newVal;
    }
  },
};
</script>
<style scoped>
  /deep/ .el-pagination .el-pager li{
    font-size: 15px;
    font-weight: 500;
    background:none;
  }

  /deep/ .el-pagination .el-pagination__total{
    font-size: 15px;
  }
</style>
<style >



.van-empty__description {
  font-size: 18px;
}

.table-label2{
  color: black;
}



</style>




// WEBPACK FOOTER //
// src/components/ReportLog/po-tablepage.vue